import {
  ResultType, TargetGroup, TariffCatalogType, TariffOfferType,
} from '@/types/av-check';
import { maxBy } from 'lodash';

export const isAlternateTariffOffer = (tariffOffer: TariffOfferType | undefined) => tariffOffer?.externalId && tariffOffer?.alternateTo;

export const getAccumulatedRank = (tariffOffer: TariffOfferType) => ((tariffOffer.technicalRank * 1000) - tariffOffer.accessTechnologyPriority);

export function getTariffOfferComparator(): (a: TariffOfferType, b: TariffOfferType) => number {
  return (a, b) => (getAccumulatedRank(b) - getAccumulatedRank(a));
}

export function getTariffCatalogComparator(): (a: TariffCatalogType, b: TariffCatalogType) => number {
  return (a, b) => {
    const topRankTariffOfferOfA = maxBy([a.dslTariffOffer, a.coaxTariffOffer, a.fmsTariffOffer, a.ftthTariffOffer], 'technicalRank');
    const topRankTariffOfferOfB = maxBy([b.dslTariffOffer, b.coaxTariffOffer, b.fmsTariffOffer, b.ftthTariffOffer], 'technicalRank');
    if(topRankTariffOfferOfA && topRankTariffOfferOfB){
      return  topRankTariffOfferOfB.technicalRank === topRankTariffOfferOfA.technicalRank ? accessTechnologyPriorityComparator(a, b) : topRankTariffOfferOfB.technicalRank - topRankTariffOfferOfA.technicalRank;
    }
    else{
      return 0;
    }
  };
}

export function accessTechnologyPriorityComparator(a: TariffCatalogType, b: TariffCatalogType): number {
  const topPrioTariffOfferOfA = maxBy([a.dslTariffOffer, a.coaxTariffOffer, a.fmsTariffOffer, a.ftthTariffOffer], 'accessTechnologyPriority');
  const topPrioTariffOfferOfB = maxBy([b.dslTariffOffer, b.coaxTariffOffer, b.fmsTariffOffer, b.ftthTariffOffer], 'accessTechnologyPriority');
  return topPrioTariffOfferOfA && topPrioTariffOfferOfB ? topPrioTariffOfferOfA.accessTechnologyPriority - topPrioTariffOfferOfB.accessTechnologyPriority : 0;
}

export const getAvailableTariffs = (tariffCatalog: TariffCatalogType) => {
  const availableTariffs: TariffOfferType[] = [];
  if (tariffCatalog.coaxTariffOffer) {
    availableTariffs.push(tariffCatalog.coaxTariffOffer);
  }
  if (tariffCatalog.dslTariffOffer) {
    availableTariffs.push(tariffCatalog.dslTariffOffer);
  }
  if (tariffCatalog.fmsTariffOffer) {
    availableTariffs.push(tariffCatalog.fmsTariffOffer);
  }
  if (tariffCatalog.ftthTariffOffer) {
    availableTariffs.push(tariffCatalog.ftthTariffOffer);
  }
  return availableTariffs;
};

export function getTariffNameDetails(availableTariffsInGroup: TariffOfferType[],selectedTariff: TariffOfferType): string[]{
  let TariffName : string[] = [];
  for (let availableTariffs of availableTariffsInGroup){
    if(availableTariffs.charges.recurringCosts !== selectedTariff.charges.recurringDetails.BASE_CHARGE){
      TariffName.push(getTariffName(availableTariffs.accessTechnology))
    }
  }
  return TariffName;
}

export function getTariffName(tariffName: string){
  if(tariffName == "COAX"){
    return "Kabel"
  }
  if(tariffName == "DSL"){
    return "DSL"
  }
  if(tariffName == "FMS"){
    return "LTE/5G"
  }
  if(tariffName == "FTTH"){
    return "FTTH"
  }
  return tariffName;
}

export function cmsSnippetGenerator(DISPLAYED_TARIFF: string,VARIED_TARIFFS: string, hint1: string, hint2:string, hint3:string){
  if(VARIED_TARIFFS.includes(DISPLAYED_TARIFF)){
    return hint3;
  }else{
    return hint1.concat(hint2);
  }
}

export function getChargesNatureForTechnologySelectionModal(availableTariffsInGroup: TariffOfferType[]): string{
  if(availableTariffsInGroup.length >= 1) {
    if(availableTariffsInGroup.find((availableTariffs) => (availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE > 0 || availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE < 0))){
      return "TECHNOLOGY_PRICING";
    }
  }
  return "BASE";
}

export function getChargesNatureForTechnologyPricing(availableTariffsInGroup: TariffOfferType[]): string{
  if(availableTariffsInGroup.length > 1) {
    if(availableTariffsInGroup.find((availableTariffs) => (availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE > 0 || availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE < 0))){
        return "TECHNOLOGY_PRICING";
      }
  }
  return "BASE";
}

export function getChargesForTariffOfferGroup(availableTariffsInGroup: TariffOfferType[]): TariffOfferType{
  if(availableTariffsInGroup.length > 1) {
   if(availableTariffsInGroup.find((availableTariffs) => (availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE > 0 || availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE < 0))){
     for (let availableTariffs of availableTariffsInGroup){
       if(availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE == 0 || !availableTariffs.charges.recurringDetails.TECHNOLOGY_CHARGE){
         return availableTariffs;
       }
     }
   }
  }
  return availableTariffsInGroup[0];
}

export function isTariffOfferGroupContainingXXLTariff(availableTariffsInGroup: TariffOfferType[]): boolean {
    if (availableTariffsInGroup.length > 1) {
        for (let availableTariffs of availableTariffsInGroup) {
            if (availableTariffs.offerName.includes('xxl'))
                return true;
        }
    }
    return false;
}

// TODO statement '|| sortedTariffCatalog[0]' should be removed when TARO is providing valid master alternate structure
export const getMainTariffOffer = (tariffCatalog: TariffCatalogType) => {
  const sortedTariffCatalog = getAvailableTariffs(tariffCatalog).sort(getTariffOfferComparator());
  return sortedTariffCatalog.find((tariff) => !isAlternateTariffOffer(tariff)) || sortedTariffCatalog[0];
};

/*
Returns mainTariff if zero or multiple Tariffs with HighlightTechnology flag are found
*/
export const getHighlightedTechnology = (tariffCatalog: TariffCatalogType) => {
  const tariffCatalogArray = getAvailableTariffs(tariffCatalog);
  const tariffsWithHighlightTechnology: Array<TariffOfferType> = tariffCatalogArray.filter((tariff) => tariff.highlightTechnology);
  if (tariffsWithHighlightTechnology.length !== 1) {
    // eslint-disable-next-line max-len
    console.log(`Found ${tariffsWithHighlightTechnology.length} tariffs with HighlightTechnology flag for tariff group${tariffCatalogArray[0].offerName}`);
    return getMainTariffOffer(tariffCatalog);
  }
  return tariffsWithHighlightTechnology[0];
};

// eslint-disable-next-line import/prefer-default-export
export const isHighlightedProduct = (tariffCatalog: TariffCatalogType) => {
  const availableTariffs = getAvailableTariffs(tariffCatalog);
  return !!availableTariffs.find((tariff) => tariff.highlightProduct);
};

export function getHighlightedProduct(tariffCatalogs: TariffCatalogType[]): TariffCatalogType | undefined {
  return tariffCatalogs.find((catalog) => isHighlightedProduct(catalog));
}

export function getTariffOffers(result: ResultType | undefined): TariffOfferType[] {
  return result?.tariffOffers || [];
}

export function getAvailableTargetGroups(tariffOffers: TariffOfferType[]): TargetGroup[] {
  return Object.keys(TargetGroup)
    .filter((targetGroup) => tariffOffers.find((o) => o.targetGroup === targetGroup && !o.specialReservation) !== undefined)
    .map((targetGroup) => (TargetGroup[targetGroup as keyof typeof TargetGroup]) as TargetGroup);
}

export function getAvailableContractDurations(tariffOffers: TariffOfferType[]): Number[] {
  return tariffOffers
    .map((tariffOffer: TariffOfferType) => tariffOffer.contractDuration)
    // next line makes the array of contract durations unique eg. [1, 24, 1] -> [1, 24]
    .filter((contractDuration: number, index: number, self: number[]) => self.indexOf(contractDuration) === index)
    .sort((a: number, b: number) => b - a);
}

export function getCurrentTargetGroup(availableTargetGroups: TargetGroup[], current: TargetGroup = TargetGroup.PRIVATKUNDEN): TargetGroup {
  if (availableTargetGroups.length === 0) {
    return TargetGroup.PRIVATKUNDEN;
  }
  return availableTargetGroups.indexOf(current) > 0 ? current : availableTargetGroups[0];
}

export function getCurrentContractDuration(availableContractDurations: Number[], current: Number = 24): Number {
  if (availableContractDurations.length === 0) {
    return 24;
  }
  return availableContractDurations.indexOf(current) > 0 ? current : availableContractDurations[0];
}

export function getOffersForTargetGroup(tariffOffers: TariffOfferType[], targetGroup: TargetGroup): TariffOfferType[] {
  return tariffOffers.filter((tariffOffer) => tariffOffer.targetGroup === targetGroup);
}

export function getOffersForContractDuration(tariffOffers: TariffOfferType[], contractDuration: number): TariffOfferType[] {
  return tariffOffers.filter((tariffOffer) => tariffOffer.contractDuration === contractDuration);
}